module.exports = __webpack_public_path__ + "static/img/pgyh5.a554f86.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pgyh5.png
// module id = b0Gt
// module chunks = 0